import { render, staticRenderFns } from "./MemoUploaderComponent.vue?vue&type=template&id=3a04839a&"
import script from "./MemoUploaderComponent.vue?vue&type=script&lang=js&"
export * from "./MemoUploaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports